
import { Vue, Component, Prop } from 'vue-property-decorator';
import Draggable from '../utilities/draggable.vue';

@Component({
	components:{
		"draggable": Draggable
	}
})
export default class GenericAdvancedTooltip extends Vue {
	@Prop({ type: Boolean, default: false })
	readonly value: boolean;

	@Prop({ type: String, default: "" })
	readonly title: string;

	@Prop({ type: String, default: "" })
	readonly dataCy: string;

	private mounted(): void {
		if (this.isToolTipVisible) {
			this.$nextTick(() => {
				this.positionTooltip();
			});
		}
	}

	private updated(): void {
		if (this.isToolTipVisible) {
			this.$nextTick(() => {
				this.positionTooltip();
			});
		}
	}

	private get isToolTipVisible(): boolean {
		return this.value;
	}

	private set isToolTipVisible(value: boolean) {
		this.$emit('input', value);
	}

	private closeToolTip(): void {
		this.isToolTipVisible = false;
	}

	private positionTooltip(): void {
		const draggable = this.$el as HTMLElement;

		if (!draggable) {
			return;
		}

		const rect = draggable.getBoundingClientRect();

		let leftPos = parseInt(draggable.style.left, 10) || 0;

		// If horizontal position is not explicitly set (initial render)
		if (draggable.style.left === "") {
			// Center horizontally in the viewport
			leftPos = (window.innerWidth - rect.width) / 2;
		}

		if (rect.right > window.innerWidth) {
			leftPos = Math.max(20, window.innerWidth - rect.width - 20);
		}

		if (rect.left < 0) {
			leftPos = 20;
		}

		draggable.style.position = 'fixed';
		draggable.style.left = `${leftPos}px`;
	}
}
